import { getProp } from '@lib/generic.utils'
import NestedFileDownloadLink from '@components/ag-grid-helpers/NestedFileDownloadLink'
import { agPriceCol, agStartDateCol } from '@/ag-grid/ag-columns'

export default {
  computed: {
    gridOptions() {
      return {
        columnDefs: [
          {
            headerName: 'License Name',
            field: 'name',
            tooltipField: 'name',
            type: ['textFilterColumn'],
            cellRendererFramework: 'LinkRenderer',
            cellRendererParams: params => {
              return {
                route: `/licenses/${params.data.id}`
              }
            }
          },

          {
            headerName: 'Publisher',
            field: 'publisher',
            tooltipValueGetter: params => getProp(params.value, 'name', 'N/A'),
            type: ['textFilterColumn'],
            cellRendererFramework: 'LinkRenderer',
            cellRendererParams: params => {
              return {
                route: `/publishers/${params.data.publisher.id}`,
                value: params.value.name
              }
            }
          },

          {
            headerName: 'License Manager',
            field: 'owner',
            tooltipValueGetter: params => getProp(params.value, 'name', 'N/A'),
            type: ['textFilterColumn'],
            cellRenderer: params => getProp(params.value, 'name', 'N/A'),
            sort: 'desc'
          },

          agStartDateCol(),

          agStartDateCol({
            headerName: 'End date',
            field: 'end_date'
          }),

          agPriceCol('Subscriptions', 'subscriptions_count', { cellRenderer: params => params.value }),

          {
            headerName: 'License file',
            field: 'license_file',
            cellRendererFramework: NestedFileDownloadLink,
            filter: false
          }
        ],

        defaultColDef: {
          floatingFilter: true
        },

        suppressRowClickSelection: true,
        rowModelType: 'serverSide',
        serverSideStoreType: 'partial',
        cacheBlockSize: 40
      }
    }
  }
}
